import renderIcon from 'helpers/renderIcon';
import * as React from 'react';

interface IProps extends React.PropsWithChildren<{}> {
	title: React.ReactNode;
	buttonClick?: () => void;
	onToggle?: (open: boolean) => void;
	onClick?: () => void;
	buttonTitle?: string;
	closed?: boolean;
	className?: string;
	isArrowIcon?: boolean;
	leftElement?: 'checked' | 'unchecked' | 'partially_checked';
}

const Expandable: React.FC<IProps> = ({
	closed,
	title,
	buttonClick,
	buttonTitle,
	onToggle,
	onClick,
	children,
	className,
	isArrowIcon,
	leftElement,
}: IProps) => {
	let button: JSX.Element = null;
	if (buttonTitle) {
		button = (
			<button type="button" className="btnText" onClick={buttonClick}>
				{buttonTitle}
			</button>
		);
	}
	const ref = React.useRef<HTMLDetailsElement>(null);

	const onClickHandler = () => {
		if (onClick) onClick();
	};

	const icon = isArrowIcon ? 'accordion_arrow' : 'accordion';

	return (
		<details
			className={className || ''}
			ref={ref}
			open={!closed}
			onToggle={() => onToggle?.(ref.current?.open || false)}
		>
			<summary onClick={onClickHandler}>
				{leftElement ? renderIcon(leftElement, 24, 24, 'expandable-leftIcon') : null}
				<strong>{title}</strong>
				{button}
				{renderIcon(icon, undefined, undefined, 'open-indicator')}
			</summary>
			{children}
		</details>
	);
};

export { Expandable };
